import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Button, Form } from 'react-bootstrap';
import { connect } from 'react-redux';

import Testimonial from '../copmpnents/Testimonial/Testimonial.js';
import PasswordInput from '../../../components/PasswordInput';
import { resetPassword } from '../AuthActions';

import logo from './img/logo-nave-icon.svg';

// Import Style
import '../Auth.scss';

class ResetPass extends Component {
  constructor(props) {
    super(props);

    this.state = {
      token: '',
      password: '',
    };
  }

  componentDidMount() {
    this.setState({
      token: this.props.match.params.token,
    });
  }

  handleChange = (ev) => {
    this.setState({
      [ev.target.name]: ev.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.resetPassword({
      token: this.state.token,
      password: this.state.password,
    });
  };

  render() {
    return (
      <div className='login_bg'>
        <div className='login_form'>
          <div className='logo'>
            <img src={logo} alt="" />
          </div>
          <div className='login_content'>
            <div className='left_part'>
              <h1>Partner Portal</h1>
              <Form className='form' noValidate onSubmit={this.handleSubmit}>
                <PasswordInput
                  name="password"
                  id="password"
                  placeholder="New Password"
                  value={this.state.password}
                  onChange={this.handleChange}
                />
                <Button type="submit" className="mt-4" variant="primary">
                  Reset
                </Button>
              </Form>
            </div>
            
            <div className='right_part'>
              <Testimonial />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    resetPassword: (body) => dispatch(resetPassword(body)),
  };
};

export default withRouter(connect(undefined, mapDispatchToProps)(ResetPass));
